import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useCallback } from 'react';
import { Button, Card, CardHeader, Collapse } from 'reactstrap';
import './index.scss';

export const ControlledAccordionCollapse = ({
    defaultOpen = false,
    secondaryAction = null,
    title,
    children,
    open,
    setOpen,
    CollapseProps = {},
}) => {
    const handleToggle = useCallback(() => setOpen(!open), [open, setOpen]);

    return (
        <Card className="accordion-card">
            <CardHeader className="d-flex flex-row justify-content-between align-items-center">
                <div>
                    <Button
                        color="link"
                        onClick={handleToggle}
                        className="p-0"
                        size="sm"
                    >
                        <FontAwesomeIcon
                            className="mr-1"
                            icon={
                                !open
                                    ? faChevronDown
                                    : faChevronUp
                            }
                            title={
                                open
                                    ? 'HideDetails'
                                    : 'Show Details'
                            }
                        />
                        <strong>{title}</strong>
                    </Button>
                </div>

                {Boolean(secondaryAction) && (
                    <div className="accordion-secondary-action">
                        {secondaryAction}
                    </div>
                )}
            </CardHeader>

            <Collapse isOpen={open} {...open ? CollapseProps : {}}>
                {children}
            </Collapse>
        </Card>
    );
};